import manifest from './manifest.json';

/** PWA manifest + 界面品牌文案的唯一配置源：src/config/manifest.json */
export interface AppManifest {
  short_name: string;
  name: string;
  description: string;
  companyName: string;
  companyFullName: string;
  tagline: string;
  copyright: string;
  logoText: string;
  icons: Array<{ src: string; type: string; sizes: string }>;
  start_url: string;
  display: string;
  theme_color: string;
  background_color: string;
}

export const appManifest = manifest as AppManifest;

/** 界面组件统一读取此对象（由 manifest.json 映射，勿在此硬编码文案） */
export const BRAND = {
  companyName: appManifest.companyName,
  companyFullName: appManifest.companyFullName,
  shortName: appManifest.short_name,
  systemName: appManifest.name,
  tagline: appManifest.tagline || appManifest.description,
  copyright: appManifest.copyright,
  logoText: appManifest.logoText || appManifest.companyName,
} as const;

export type BrandConfig = typeof BRAND;

/** 同步 document 标题与 meta（构建时 sync 脚本也会写入 index.html） */
export function applyBrandToDocument(): void {
  document.title = BRAND.systemName;

  const description = appManifest.description;
  let meta = document.querySelector('meta[name="description"]');
  if (!meta) {
    meta = document.createElement('meta');
    meta.setAttribute('name', 'description');
    document.head.appendChild(meta);
  }
  meta.setAttribute('content', description);

  let theme = document.querySelector('meta[name="theme-color"]');
  if (!theme) {
    theme = document.createElement('meta');
    theme.setAttribute('name', 'theme-color');
    document.head.appendChild(theme);
  }
  theme.setAttribute('content', appManifest.theme_color);
}
